import { useSpinner } from "@/context/contexts/SpinnerContext";
import React from "react";

const withSpinner = (Component) => (props) => {
  const { setShowSpinner } = useSpinner();
  return <Component {...props} setShowSpinner={setShowSpinner} />;
};

export default withSpinner;
